import { ProgressToastFunctions } from 'components/toasts/createProgressToast';
import Toast from 'components/toasts/Toast';
import { ToastErrorWithBugReportLink } from 'components/toasts/ToastErrorWithBugReportLink';
import { getErrorCodeFromAxiosError } from 'features/teamInvitation/getErrorCodeFromAxiosError';
import { useRef } from 'react';
import { handleCommonApiError } from 'services/api/utils/handleCommonApiError';

export const useShowErrorToast = () => {
  const progressToast = useRef<ProgressToastFunctions | null>();

  const showErrorToast = (err: unknown) => {
    const errorCode = getErrorCodeFromAxiosError(err);
    if (errorCode) {
      progressToast.current?.error({
        render: Toast.backendError(handleCommonApiError(errorCode)),
        icon: false,
        autoClose: 10000,
      });
    } else {
      progressToast.current?.error({
        render: <ToastErrorWithBugReportLink />,
        icon: false,
        autoClose: 10000,
      });
    }
  };

  return { showErrorToast };
};
